import * as _ from 'lodash';

export const getParamsFromQueryStringParameters = (queryStringParameters: string): { [query: string]: string } => {
    const result = {}
    if (queryStringParameters) {
        const queryParameters = queryStringParameters.split("?");
        if (queryParameters.length > 1) {
            const parameters = queryParameters[1].split("&");
            for (const param of parameters) {
                const byEqual = param.split("=");
                result[byEqual[0]] = byEqual[1]
            }
        }
    }
    return result;
}

export const isNonEmptyString = (str: string) => {
    if (!str) {
        return false;
    }
    return !_.isEmpty(_.trim(str));
}

export const isValidNumber = (str: string) => {
    const regEx = new RegExp(/^((([1-9][0-9]*)|0)(\.[0-9]{0,2})?)?$/);
    return regEx.test(str);
}

export const isValidIntegerNumber = (str: string) => {
    const regEx = new RegExp(/^(([1-9][0-9]*)|0)$/);
    return regEx.test(str);
}

export const isValidNumberStartingWithZero = (str: string) => {
    const regEx = new RegExp(/^((([0-9]*)|0)(\.[0-9]{0,2})?)?$/);
    return regEx.test(str);
}

export const isValidIntegerNumberStartingWithZero = (str: string) => {
    const regEx = new RegExp(/^(([0-9]*)|0)$/);
    return regEx.test(str);
}

export const isValidNumberEndingInDot = (str: string) => {
    const regEx = new RegExp(/^((([0-9]*)|0)(\.)?)?$/);
    return regEx.test(str);
}

export const isValidString = (str: string): boolean => {
    return !_.isEmpty(_.trim(str));
}

export const getTagsInText = (textEntered: string): string[] => {
    const regEx = /<(.*?)>/g;
    const tags: string[] = [];

    let match;
    do {
        match = regEx.exec(textEntered);
        if (match) {
            tags.push(match[1]);
        }
    } while (match);
    return tags;
}

export const lengthInUtf8KB = (obj: any): number => {
    const str = JSON.stringify(obj);
    // Matches only the 10.. bytes that are non-initial characters in a multi-byte sequence.
    var m = encodeURIComponent(str).match(/%[89ABab]/g);
    return (str.length + (m ? m.length : 0)) / 1024;
}

//Money Format: This is copied from Reporting Microservice in the MetricFormatter
export const getMoneySymbol = () => {
    return "$"
};

export const regexpNumbers = /(\d)(?=(\d{3})+(?!\d))/g

export const NUMBER_OF_DECIMALS = 2;

export const formatNumber = (value) => {
    return value.toFixed(0).replace(regexpNumbers, '$1,')
};

export const formatDecimal = (value: number) => {
    return value.toFixed(NUMBER_OF_DECIMALS).replace(regexpNumbers, '$1,')
};

export const formatMoney = (value: number) => {
    return `${getMoneySymbol()} ${formatDecimal(value)}`;
};


export const getEnginePerPackage = (lmDealerPackage: string|undefined): string => {
    if (lmDealerPackage && lmDealerPackage == "ELITE") {
        return "CHATMETER";
    }
    return "GMB";
}
